
import { Link } from 'react-router-dom';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const FaqSeoBlock = () => {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation({ threshold: 0.15 });
  const { ref: articlesRef, isVisible: articlesVisible } = useScrollAnimation({ threshold: 0.1 });
  const { ref: topicsRef, isVisible: topicsVisible } = useScrollAnimation({ threshold: 0.15 });
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation({ threshold: 0.2 });

  const popularTopics = [
    'Desguace Gavá',
    'Vender coche siniestrado',
    'Precio chatarra coche',
    'Documentación baja vehículo',
    'Grúa gratis Gavá',
    'Piezas segunda mano',
    'Certificado destrucción',
    'Coche averiado Gavá',
    'Recogida vehículos',
    'Siniestro total seguro',
    'Coche heredado desguace',
    'ITV caducada vender',
    'Reciclaje vehículos',
    'Baix Llobregat desguace',
    'Pago inmediato coche',
  ];

  const relatedArticles = [
    {
      title: 'Cómo Vender un Coche Siniestrado en Gavá: Guía Completa 2025',
      slug: 'como-vender-coche-siniestrado-gava',
      image: 'https://public.readdy.ai/ai/img_res/0df7afe49356630d9899c0c49375f93f.jpg',
    },
    {
      title: 'Documentación Necesaria para Dar de Baja un Vehículo en Gavá',
      slug: 'documentacion-baja-vehiculo-gava',
      image: 'https://readdy.ai/api/search-image?query=official%20documents%20paperwork%20car%20registration%20vehicle%20papers%20on%20desk%20professional%20office%20setting%20warm%20lighting%20organized%20clean%20modern&width=400&height=250&seq=faq-seo-art2&orientation=landscape',
    },
    {
      title: 'Precios de Chatarra de Coches en Gavá: Actualización 2025',
      slug: 'precios-chatarra-coches-gava-2025',
      image: 'https://readdy.ai/api/search-image?query=scrap%20metal%20yard%20with%20organized%20car%20parts%20recycling%20facility%20industrial%20setting%20warm%20tones%20professional%20photography%20daytime%20clean%20modern&width=400&height=250&seq=faq-seo-art3&orientation=landscape',
    },
  ];

  return (
    <section className="py-20 px-6 lg:px-12 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div
          ref={headerRef}
          className={`text-center mb-14 transition-all duration-700 ${
            headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Información Completa sobre <span className="text-emerald-600">Desguace en Gavá</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Artículos relacionados y temas populares para resolver todas tus dudas sobre venta de coches y desguace en Gavá
          </p>
        </div>

        <div ref={articlesRef} className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {relatedArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className={`bg-white rounded-2xl overflow-hidden border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all group cursor-pointer duration-600 ${
                articlesVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - Desguace Gavá`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5">
                <h4 className="text-base font-bold text-gray-900 group-hover:text-emerald-600 transition-colors leading-snug">
                  <a href={`/blog/${article.slug}`}>{article.title}</a>
                </h4>
                <span className="text-emerald-600 text-sm font-medium mt-3 inline-flex items-center space-x-1">
                  <span>Leer artículo</span>
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div
          ref={topicsRef}
          className={`bg-white rounded-2xl p-10 border border-gray-100 transition-all duration-700 ${
            topicsVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          }`}
        >
          <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">
            Temas Populares sobre Desguace en Gavá
          </h3>
          <div className="flex flex-wrap justify-center gap-2">
            {popularTopics.map((topic, index) => (
              <span
                key={topic}
                className={`bg-gray-50 text-gray-600 px-4 py-2 rounded-full text-sm font-medium hover:bg-emerald-50 hover:text-emerald-700 transition-all cursor-pointer duration-500 ${
                  topicsVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
                }`}
                style={{ transitionDelay: `${200 + index * 40}ms` }}
              >
                {topic}
              </span>
            ))}
          </div>
        </div>

        <div
          ref={ctaRef}
          className={`mt-16 bg-emerald-600 rounded-2xl p-10 text-center transition-all duration-700 ${
            ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
            ¿Quieres vender tu coche en Gavá hoy?
          </h3>
          <p className="text-emerald-100 mb-8 max-w-2xl mx-auto">
            Valoración gratuita en menos de 2 horas. Recogida con grúa gratis y pago inmediato en efectivo o transferencia.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:+34932932913"
              className="inline-flex items-center space-x-2 bg-white hover:bg-gray-100 text-emerald-700 px-8 py-4 rounded-lg font-bold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-xl"></i>
              <span>Llamar: 932 932 913</span>
            </a>
            <a
              href="https://wa.me/34932932913?text=Hola,%20tengo%20una%20pregunta%20sobre%20desguace%20en%20Gavá"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-emerald-700 hover:bg-emerald-800 text-white px-8 py-4 rounded-lg font-bold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl"></i>
              <span>WhatsApp Directo</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSeoBlock;
